import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f6f2cc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container hero__container" }
const _hoisted_2 = { class: "hero__title" }
const _hoisted_3 = { class: "hero__introduction" }
const _hoisted_4 = {
  key: 0,
  class: "hero__image_container"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hero__image_overlay" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionImages = _resolveComponent("TransitionImages")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["hero", { 'hero--with-image': _ctx.image }]),
    ref: "heroRef"
  }, [
    _createVNode(_component_TransitionImages, { images: _ctx.images }, null, 8, ["images"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.introduction), 1),
      (_ctx.image)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "hero__image",
              src: _ctx.image
            }, null, 8, _hoisted_5),
            _hoisted_6
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}